'use strict';

module.exports = '2.28.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 324
// module chunks = 142807904292071